// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_AdminOverviewResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Staff-family admin overview response — cost fields ALLOWED. Full-gated only.
 *
 * M2 (2026-08-17): every money/COGS field below is MEASURED — a real
 * SUM(ai_credit_ledger.provider_cost_usd) or a real SUM(ai_credit_wallets
 * .balance_micro) — never reconstructed from the CURRENT markup/peg_brl/
 * fx_rate_usd_brl settings. The prior `provider_cost_usd` / `raw_cost_brl` /
 * `margin` trio (controllers/ai/credits.php::estimatePeriodCost(), deleted
 * in M2) computed margin as billedBrl/markup / billedBrl, which algebraically
 * collapses to the CONSTANT (1 - 1/markup) regardless of any pack price —
 * and is retroactive, since all three inputs are CURRENT settings, so
 * re-pricing anything silently rewrote history. Removed here, not replaced:
 * there is no single "margin" field any more — a franchise selling in BRL,
 * CLP and USD cannot be reduced to one percentage without picking a currency
 * to convert into, so gross-margin-on-sale is derived by the CALLER from
 * cash_received + cogs_realized_usd.
 */
import type { AiCredits_CashReceivedRow } from './AiCredits_CashReceivedRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_AdminOverviewResponseDados {
total_micro: number
total_granted_micro: number
settle_count: number
period: string
peg_usd: string
cogs_realized_usd: string
open_credits_micro: number
liability_usd: string
granted_free_micro: number
liability_no_cash_usd: string
metered_micro: number
metered_usd: string
cash_received: AiCredits_CashReceivedRow[]
cost_rows_missing_cost: number
}

export type AiCredits_AdminOverviewResponse = ApiResponse<AiCredits_AdminOverviewResponseDados>;

registerResponseContract('AiCredits_AdminOverviewResponse', {
  total_micro:            { type: 'number',  required: true },
  total_granted_micro:    { type: 'number',  required: true },
  settle_count:           { type: 'number',  required: true },
  period:                 { type: 'string',  required: true },
  peg_usd:                { type: 'string',  required: true },
  cogs_realized_usd:      { type: 'string',  required: true },
  open_credits_micro:     { type: 'number',  required: true },
  liability_usd:          { type: 'string',  required: true },
  granted_free_micro:     { type: 'number',  required: true },
  liability_no_cash_usd:  { type: 'string',  required: true },
  metered_micro:          { type: 'number',  required: true },
  metered_usd:            { type: 'string',  required: true },
  cash_received: {
    type: 'array',
    required: true,
    items: {
      currency:       { type: 'string',  required: true },
      amount_cents:   { type: 'number',  required: true },
      purchase_count: { type: 'number',  required: true },
    },
  },
  cost_rows_missing_cost: { type: 'number',  required: true },
})
